module.exports = __webpack_public_path__ + "static/img/qr6.d4d45d51.jpeg";